import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
  Box,
  Checkbox,
  InputAdornment,
  MenuItem,
  TextField,
  Typography
} from '@mui/material';
import { useContext, useState } from 'react';
import { Facets, FilterOption } from 'types/Search';
import SearchIcon from '@mui/icons-material/Search';
import { SearchContext } from 'context/SearchContext';

interface Props {
  selectedFilterOption: string | undefined;
  setSelectedFilterOption: (a: string | undefined) => void;
  options: FilterOption[];
}

export const DropDownFilters: React.FC<Props> = props => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const {
    request: searchRequest,
    results: searchResults,
    handleToggleFilter
  } = useContext(SearchContext);

  const selectedFilterFacets = searchResults.facets[
    props.selectedFilterOption as keyof Facets
  ]?.filter(o => {
    if (searchQuery.trim() === '') {
      return true;
    } else {
      return o.value?.toLowerCase().includes(searchQuery.toLowerCase().trim());
    }
  });

  return (
    <>
      <Box
        key="stickyheader"
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          background: 'white',
          px: 1
        }}
      >
        <MenuItem
          onClick={() => {
            props.setSelectedFilterOption(undefined);
            setSearchQuery('');
          }}
          sx={{
            display: {
              xs: 'flex',
              sm: 'none',
              mb: 1
            }
          }}
        >
          <ArrowBackIosIcon color="primary" sx={{ mr: 1 }} />
          {props.options.find(o => o.key === props.selectedFilterOption)?.label}
        </MenuItem>
        <TextField
          sx={{ mt: 2, mb: 0.5 }}
          label="Search"
          size="small"
          fullWidth
          value={searchQuery}
          autoComplete="off"
          onChange={e => {
            setSearchQuery(e.target.value);
            e.preventDefault();
            e.stopPropagation();
          }}
          onKeyDown={e => e.stopPropagation()}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }
          }}
        />
      </Box>
      {selectedFilterFacets?.length ? (
        selectedFilterFacets.map(o => (
          <MenuItem
            dense
            key={o.value}
            onClick={() =>
              props.selectedFilterOption &&
              handleToggleFilter(o.value, props.selectedFilterOption)
            }
          >
            <Checkbox
              sx={{ padding: 0.5, mr: 0.5 }}
              disableRipple
              checked={searchRequest?.filters?.some(el => el.value === o.value)}
            />
            <Typography>{`${o.value} (${o.count})`}</Typography>
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>
          <Typography
            variant="caption"
            component={'div'}
            sx={{
              textAlign: 'center',
              margin: 'auto'
            }}
          >
            No results found. <br />
            Please try another keyword
          </Typography>
        </MenuItem>
      )}
    </>
  );
};
